<!-- ChatApp.vue -->
<template>
   <div>
      <div id="chat-app">
         <div class=" chat-main-content text-center">
            <!-- <i class="circle-shape font-icon-brought-center fc_fusioncharts_short_logo"></i>-->
            <div class="custom-container-1440 ">
               <i class="circle-shape font-icon-brought-center fc_fusioncharts_short_logo"></i>
               <h4 class="line-height">How Can Ask FusionDev AI Help You?</h4>
               <p class="mb-2 mt-2">
                  A coding companion trained to answer questions about FusionCharts documentation.
               </p>
            </div>
         </div>
         <div class="response-gallery-page">
            <div ref="contentRef" class="content">
               <div ref="responseContainer" class="response-container">
                  <div class="response">
                     <div v-if="firsthelp" class="custom-container-1440 container-res ">
                        <i class="circle-shape font-icon-brought-center fc-icon-chat"></i>

                        <div class="response-box">
                           <div class="question">Welcome to Ask FusionDev AI.</div>
                           <div class="response-message">
                              <p>
                                 I’m an AI chatbot that uses several third-party solutions to
                                 provide helpful responses based on FusionCharts’ documentation.
                              </p>
                              <p>
                                 If you use Ask FusionDev AI, please note that we will record and
                                 share your questions and responses with various third parties for
                                 further analysis.
                              </p>
                              <p>
                                 The accuracy of the information cannot be guaranteed and should be
                                 separately reviewed and verified by a human.
                              </p>
                           </div>
                        </div>
                        <!--   <button @click="copy(response)">Copy</button> -->
                     </div>
                     <!-- category box -->
                     <!--<CategoryBox /> -->
                     <!-- ends here -->
                  </div>
                  <div v-for="(qa, index) in qas" :key="index" class="response">
                     <ResponseBox :question="qa.question" :response="qa.response" :index="index" />
                  </div>
                  <div v-if="firsthelp" class="response">
                     <CategoryBox @user-question="askQuestion" />
                  </div>
                  <div v-if="loading" class="custom-container-1440 container-res ">
                     <i class="circle-shape font-icon-brought-center fc-icon-chat"></i>
                     <div class="response-box" style="background: white;">
                        <div class="loading loading-container">
                           <div class="loading-animation"></div>
                           <p>FusionDev AI is typing....</p>
                        </div>
                     </div>
                     <!--   <button @click="copy(response)">Copy</button> -->
                  </div>
               </div>
            </div>
         </div>

         <div id="sidebarContainer" class="side-bar-container">
            <div class="sidebar_main">
               <div class="sidebar">
                  <ChatBox @user-question="askQuestion" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import ChatBox from './ChatBox.vue';
import ResponseBox from './ResponseBox.vue';
import CategoryBox from './CategoryBox.vue';
// import { aidaLib } from '../../util/aida';

export default {
   name: 'ChatApp',
   components: {
      ChatBox,
      ResponseBox,
      CategoryBox,
   },
   data() {
      return {
         loading: false,
         addPrompt: '', // Additional Prompt
         firsthelp: true,
         aidaLib: undefined,
         myCookieValue: null,
         qas: [], // Array to store questions and responses,
         LOG_MODULE_NAME: '[CLIENT] ',
         clientname: 'fc-code',
         clientkey: '2hjDXr5BPOxCI6BuUNaqnD8cLfCa1XYkMNPHJZBR8', // Prod
      };
   },
   mounted() {
      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://aida-lib.idera.com/version/latest/aida.min.js';
      scriptElement.type = 'text/javascript';
      scriptElement.async = true;
      document.body.appendChild(scriptElement);
   },
   methods: {
      /* setAdditionalPrompt(newValue) {
      this.addPrompt = `${newValue  } `;
    }, */
      askQuestion(question) {
         const cleanedInput = this.addPrompt + question.trim().replace(/\n/g, ' ');
         const container = this.$refs.responseContainer;
         container.scrollTop = 0;
         this.firsthelp = false;
         this.loading = true;

         let response;
         // let aidaLib  ;

         // debugger;
         // this.clientid=localStorage.getItem('aida_fc-code_user_id');
         if (!this.aidaLib) {
            this.aidaLib = aida.AIDA_Library.initialize(this.clientname, this.clientkey, '');
            // this.aidaLib =aida.AIDA_Library.initialize('fc-code','2hjDXr5BPOxCI6BuUNaqnD8cLfCa1XYkMNPHJZBR8', "");
         }

         this.aidaLib
            .askQuestion(cleanedInput)
            .then(answer => {
               // response = this.getRandomResponse([answer.aida_answer]);
               response = answer.aida_answer;
               question.trim().replace(/\n/g, ' ');
               this.qas.push({ question, response }); // Add question and response to the array
               this.loading = false;
            })
            .catch(error => {
               if (error.aida_error_description === undefined)
                  response = 'The request encountered a network error.';
               else if (
                  error.aida_error_description ===
                  'users_question : String should have at most 3000 characters'
               )
                  response = `The message should have at most 3000 characters. Please try again with a shorter message.`;
               else
                  response = `The requested errored out with error - ${error.aida_error_description}`;
               this.qas.push({ question, response });
               this.loading = false;
            });
      },
      /* getRandomResponse(responses) {
      return responses[Math.floor(Math.random() * responses.length)];
    }, */
   },
};
</script>

<style>
.custom-container-1440 {
   max-width: 1200px;
   margin: 0 auto;
   padding: 0 30px;
}
.loading-container {
   display: flex;
   /* flex-direction: column;
  justify-content: center; */
   align-items: center;
}

.loading-animation {
   border: 4px solid #f3f3f3; /* Light grey */
   border-top: 4px solid #3498db; /* Blue */
   border-radius: 50%;
   width: 23px;
   height: 23px;
   animation: spin 1s linear infinite;
   margin: 20px;
}

@keyframes spin {
   0% {
      transform: rotate(0deg);
   }
   100% {
      transform: rotate(360deg);
   }
}

.loading-container p {
   margin-bottom: 0px;
   font-size: 16px;
   color: #555;
}

.response {
   margin-bottom: 10px;
}
.container-res,
.container-ques {
   display: flex; /* or display: grid; depending on your layout preferences */
}
.question-box {
   background: white;
   width: 100%;
   border-radius: 9px;
   margin-bottom: 10px;
}
.response-box {
   /* padding: 6px 20px;*/
   background-color: #f0f0f0;
   border: 1px solid #ccc;
   border-radius: 5px;
   width: 100%;
   max-width: 98%;
}

h2 {
   text-align: center;
}

.question {
   font-weight: bold;
   margin-bottom: 10px;
   padding-left: 10px;
   padding-top: 10px;
}

.response-message {
   padding: 10px;
}
.sidebar-whitepspace {
   width: 330px;
}

.chat-main-content {
   padding-top: 16px;
}

.response-container {
   /* max-height: 500px;*/
   overflow-y: auto;
}
.response-gallery-page {
   background: #f9f9fb;
   min-height: 30vh;
}
.content {
   flex: 2;
   padding: 20px;
}
.circle-shape {
   width: 50px;
   height: 50px;
}
.circle-shape::before {
   background: linear-gradient(134.72deg, #bb88fd, #6957da);
   /*-webkit-background-clip: text;*/
   -webkit-text-fill-color: transparent;
}
.helpchat {
   display: flex;
   justify-content: center; /* Horizontally center the content */
   align-items: center; /* Vertically center the content */
   width: 100%; /* Ensure the container fills its parent */
   height: 50vh;
}
pre[class*='language-'],
.response-message pre {
   position: relative;
   overflow: auto;

   /* make space  */
   margin: 5px 0;
   padding: 1.75rem 0 1.75rem 1rem;
   border-radius: 10px;
}

pre[class*='language-'] button,
.response-message pre button {
   position: absolute;
   top: 5px;
   right: 29px;
   font-size: 13px;
   padding: 5px;
   /* background-color: #828282;*/
   border-radius: 5px;
   /* text-shadow: #c4c4c4 0 0 2px; */
   background-repeat: no-repeat;
   background-image: url(/public/images/chat-feedback/fc-icon-copy.svg);
   height: 24px;
   width: 24px;
   padding-top: 18px;
   /* flex-direction: column; */
   /* align-items: center; */
   /* text-align: center; */
   cursor: pointer;
   color: #ccc;
   text-align: center;
   background-size: cover;
   background-position: center;
   line-height: 24px;
   justify-content: center;
   display: flex;
}

pre[class*='language-'] button:hover,
.response-message pre button:hover {
   cursor: pointer;
   background-color: #bcbabb;
}
pre[class*='language-'] button:focus,
.response-message pre button:focus {
   outline: none; /* Remove the outline */
}
code.language-html {
   padding-top: 25px;
   display: block;
}
.fc-icon-chat,
.fc-icon-chat-que {
   height: 24px;
   width: 24px;
   display: inline-block;
   background-repeat: no-repeat;
   margin-right: 10px;
}
.fc-icon-chat {
   background-image: url('/public/images/fc-icon-chat.svg');
}
.fc-icon-chat-que {
   background-image: url('/public/images/chat-feedback/fc-icon-feedback-userquestion.svg');
}
.fc-icon-send {
   background-image: url('/public/images/fc-icon-chat.svg');
   height: 24px;
   width: 24px;
   display: inline-block;
   background-repeat: no-repeat;
   margin-right: 10px;
}
.fc_fusioncharts_short_logo {
   background-image: url('/public/images/chat-feedback/fc-chataIlogo-56x56.svg');
   height: 53px;
   width: 53px;
   display: inline-block;
   background-repeat: no-repeat;
}
.feedback_conatiner {
   color: #a6b2be;
}

.response-message p {
   margin-bottom: 15px;
}
.question p {
   margin-bottom: 0px;
}
.line-height {
   line-height: 12px;
}
.response-message img {
   max-width: 100%;
}
</style>
